const saturnusQuiz = [ 
    {
    question: "Saturnus adalah planet ke berapa dari Matahari?",
    options: ["5", "6", "7", "8"],
    answer: 1,
  },
  {
    question: "Saturnus paling dikenal karena memiliki?",
    options: [
      "Gunung tinggi",
      "Lautan air",
      "Cincin yang besar dan indah",
      "Warna merah",
    ],
    answer: 2,
  },
  {
    question: "Saturnus termasuk jenis planet apa?",
    options: [
      "Planet terestrial",
      "Planet raksasa gas",
      "Planet es",
      "Planet kecil",
    ],
    answer: 1,
  },
  {
    question: "Cincin Saturnus terutama tersusun dari?",
    options: [
      "Gas dan debu",
      "Batu dan es",
      "Lava cair",
      "Pasir",
    ],
    answer: 1,
  },
  {
    question: "Berapa jumlah bulan yang dimiliki Saturnus?",
    options: ["10", "27", "82", "Lebih dari 80"],
    answer: 3,
  },
  {
    question: "Bulan terbesar Saturnus bernama?",
    options: [
      "Europa",
      "Titan",
      "Ganymede",
      "Triton",
    ],
    answer: 1,
  },
  {
    question: "Apakah Saturnus dapat mengapung di air (secara teori)?",
    options: [
      "Ya, karena kepadatannya rendah",
      "Tidak, karena sangat berat",
      "Hanya di lautan khusus",
      "Tidak bisa diukur",
    ],
    answer: 0,
  },
  {
    question: "Waktu rotasi Saturnus (1 hari di Saturnus) adalah?",
    options: [
      "Sekitar 10 jam",
      "24 jam",
      "7 hari",
      "365 hari",
    ],
    answer: 0,
  },
  {
    question: "Warna dominan Saturnus adalah?",
    options: [
      "Merah",
      "Kuning keemasan",
      "Biru",
      "Hijau",
    ],
    answer: 1,
  },
  {
    question: "Mengapa Saturnus penting untuk diteliti?",
    options: [
      "Karena memiliki kehidupan",
      "Karena cincinnya unik dan kompleks",
      "Karena paling panas",
      "Karena paling dekat Matahari",
    ],
    answer: 1,
  },
]

export default saturnusQuiz;